import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { Observable, Subscriber } from 'rxjs';
import { formatDate, Location } from '@angular/common';

@Component({
  selector: 'app-provisional',
  templateUrl: './provisional.component.html',
  styleUrls: ['./provisional.component.scss']
})
export class ProvisionalComponent implements OnInit {
  provisionalForm: FormGroup;
  @ViewChild('fileUploader') fileUploader: ElementRef;
  Tclcdata = [];
  dialogRef: MatDialogRef<any>;
  TCList: any;
  filterTCList: any;
  filteredCollegeList: any;
  CollegeList: any;
  examList: any;
  filteredExamList: any;
  filePathData: any[] = [];
  courseStreamList: any;
  filteredStreamList: any;
  DestcollegeList: any;
  filteredDestCollegeList: any;
  StuId: any;
  TclcData: any;
  Table = false;
  Approved = false;
  InstId: any;
  RptCode: number;
  College = true;
  PayFee = false
  CgCode: any;
  filteredDestUniList: any;
  allMandatoryUploaded:boolean=false;
  DestUniList: any;
  Status: string;
  // SaveDisabled: boolean;
  SaveDisabled = false;
  CertStatus: any;
  Other = false;
  SaveBtn = false;
  UpdateBtn = false;
  PayDisabled = false;
  PayRecpt = false;
  DocTable = false;
  StuFullName: string;
  currentdate: Date;
  formattedPrn: string;
  RgNo: string;
  PreFix: any;
  fileName: string;
  errormessage: string;
  isdisabled = false;
  documents = [
    { id: 1, name: 'First Year to Final Year Marksheets (One Set)' },
    { id: 2, name: 'Internship Completion Certificate, Passing Certificate, Degree Certificate' },
    { id: 3, name: 'Registration Certificate, Identity Certificate (Aadhar/Passport)' }
  ];
  uploadDoc: any;
  fileUploads: any;
  AppliDate: any;
  RegnNo: any;
  errMsg: any;
  DocView = false;
  TclcId: any;
  TclcDocData: any;
  UpdateDisabled = false;
  ForeignUni: boolean;
  UniName: string;
  UniAddress: string;
  IsWES: boolean;
  isSameAddr: boolean;
  isreadonly = false;

  TranscriptData: any;
  uploadDoc2: any;
  FeeStatus: any;
  AdminUpload: any = [];
  fatherFullName: string;
  motherFullName: string;
  saveClicked: boolean = false;
  certType: any;
  updateId: any;
  monthList: any;
  filteredMonthList: any;
  ExamMonth: any;
  PassYearList: { year: number; description: string; }[];
  // PhdYearList: { year: number; description :string; }[];
  filteredPassYearList: { year: number; description: string; }[];
  filteredPassYearList2: { year: number; description: string; }[];
  filteredPhdYearList: { year: number; description: string; }[];
  showSoftCopy: boolean;
  // updateId:any;
  courseList: any;
  filteredCourseList: any[] = [];
  courseName: any;
  AdminTclc: any;
  internCourse: any;
  courses: any;
  showInput: boolean = false
  Specialization: boolean = false
  isPhdCourseSelected: boolean = false
  PhdYearList: { year: number; description: string; }[];
  CourseCoCode: any;
  session: any;
  constructor(private http: HttpClient, private location: Location, private cdr: ChangeDetectorRef, public umsService: UmsService, private fb: FormBuilder, public dialog: MatDialog,
    private modalPopupService: ModalpopService, private spinner: NgxSpinnerService, public router: Router,
  ) { }
  BranchId = 0;
  minDate = new Date(2000, 0, 1);
  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)
  CourseCode: any;
  Internship: any;
  specializationOptions = [
    "Medical Laboratory Technology",
    "Cardiac Care Technology",
    "Dialysis Technology",
    "Trauma and Emergency",
    "OT Technology",
    "Anaesthesia and Critical Care",
    "Blood Banking Technology",
    "ICU Technology",
    "Radiography and Imaging Technology",
    "Vision Technician",
    "In Pharmacy",
    "Nurse Practitioner In Critical Care",
    "Post Basic Diploma In Oncology",
    "In Cardiac Care Technology",
    "In Dialysis Technology",
    "In ICU Technology",
    "In OT Technology",
    "In Medical Laboratory Technology",
    "In Medical Radiographic",
    "In Physiotherapy"
  ];

  SpecializationDrop: boolean = false;
  specItem: any;
  CourseFullName: any;
  internDate: any;
  CertificateType = "PC,OPC,MC,RC";
  sortSequence: any;
  ReportCoCode: any;
  uploadedDoc:any=[];

  ngOnInit(): void {
    this.currentdate = new Date();
    this.UpdateBtn = false;
    this.isdisabled = false;
    this.DocTable = false;
    this.DocView = false;
    this.SaveBtn = true;
    this.Other = false;
    this.College = true;
    this.PayFee = false;
    this.Table = false;
    this.UpdateDisabled = false;
    this.PayDisabled = false
    this.ExamMonth = ''
    this.RgNo = sessionStorage.getItem('StudentRGID');
    this.provisionalForm = this.fb.group({
      CertName: new FormControl(''),
      StuName: new FormControl('', Validators.required),
      StuFatherName: new FormControl(''),
      StuMotherName: new FormControl(''),
      StuPRN: new FormControl(''),
      StuPhone: new FormControl('',[Validators.pattern('(0|91)?[6-9][0-9]{9}')]),
      StuAdd: new FormControl(''),
      EmailId: new FormControl('', [Validators.required,Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]),
      LastInst: new FormControl('', Validators.required),
      CoCode: new FormControl('', Validators.required),
      LastRollNo: new FormControl(''),
      LastExam: new FormControl(''),
      SnNo: new FormControl(''),
      DocStatus: new FormControl(''),
      CertType: new FormControl(''),
      StuId: new FormControl(''),
      FeeStatus: new FormControl(''),
      CertStatus: new FormControl(''),
      StausBy: new FormControl(''),
      Comment: new FormControl(''),
      ProvisionalId: new FormControl(''),
      StuCertCopies: new FormControl(''),
      TranscriptId: new FormControl(''),
      arrData: this.fb.array([], Validators.required),
      docFile: new FormControl(''),
      declaration: new FormControl(false, Validators.requiredTrue),
      HardCopy: new FormControl(''),
      EmDate: new FormControl(''),
      InternDate: new FormControl(''),
      Specialization: new FormControl(''),
      StuRank: new FormControl(''),
      TotalCandidate: new FormControl(''),
      EmMonth: new FormControl(''),
      EmYear: new FormControl(''),
      StuCertificate: new FormControl(''),
      regnYear: new FormControl(''),
      Faculty: new FormControl(''),
      PhdCompletionYear: new FormControl(''),
      ThesisTitle: new FormControl(''),
    })
    this.spinner.show()
    this.fetchPersonal()
    this.fetchTcLcMc()
    this.getMonth()
    this.fetchPassYear()
    this.fetchPhdYear();
    //this.getCourseData()

    this.getSecretData();
    this.transPRN(this.RgNo);
    this.ValidateCertificateFee();
    // this.getProvisionalData(sessionStorage.getItem('StudentRGID'))
    // this.geOriginalPassCertificateData(sessionStorage.getItem('StudentRGID'))
    // this.geMigrationCertificateData(sessionStorage.getItem('StudentRGID'))
    // this.geRankCertificateData(sessionStorage.getItem('StudentRGID'))
  }

  fetchPersonal() {
    this.calledApi++;
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe(async (res) => {
      if (res.status) {

        sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
        this.StuId = res.data[0].StuId;
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        };
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      };
    })
  }

  fetchPassYear() {
    const currentYear = new Date().getFullYear();
    this.PassYearList = Array.from({ length: 100 }, (_, i) => {
      const year = currentYear - i;
      return { year, description: `Year ${year}` };
    });
    this.filteredPassYearList = [...this.PassYearList];
    this.filteredPassYearList2 = [...this.PassYearList];
  }


  onYearSelect(year2: number) {
    if (!this.PassYearList.some(y => y.year === year2)) {
      this.PassYearList.push({ year: year2, description: `Year ${year2}` });
    }
    this.filteredPassYearList = Array.from(new Set(this.PassYearList.map(y => y.year)))
      .map(year => this.PassYearList.find(y => y.year === year)!);
    this.filteredPassYearList2 = Array.from(new Set(this.PassYearList.map(y => y.year)))
      .map(year => this.PassYearList.find(y => y.year === year)!);
    this.provisionalForm.controls['EmYear'].setValue(year2);

  }

  onMonthSelect(month) {
    this.ExamMonth = month
    this.monthList.forEach(element => {
      if (element.CdDesc == month) {
        this.provisionalForm.controls['EmMonth'].setValue(element.CdCode);
      }
    });

  }

  getMonth() {
    // this.spinner.show();
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'EMon'
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide();
        this.monthList = res.data;
        this.filteredMonthList = this.monthList.slice();
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        // this.spinner.hide();
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  getMonthName(data) {
    this.ExamMonth = data

  }

  fetchTcLcMc() {
    // this.spinner.show()
    this.calledApi++;
    const payload = {};
    payload['CdType'] = 'PSTR';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.TCList = res.data;
        this.filterTCList = this.TCList.slice();
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        // this.spinner.hide()
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide()
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  ShowTable(data) {

    this.spinner.show()
    // this.provisionalForm.reset();
    this.certType = data
    this.getCourseData();
    this.StuId = this.StuId

    if (data == 'PC') {
      this.provisionalForm.controls["StuCertificate"].setValue(data);

      this.getProvisionalData(this.StuId)
      this.provisionalForm.get('StuPRN').setValidators([Validators.required]);
      this.provisionalForm.get('StuPRN').updateValueAndValidity();
      this.provisionalForm.get('regnYear').setValidators([Validators.required]);
      this.provisionalForm.get('regnYear').updateValueAndValidity();
      this.provisionalForm.get('LastRollNo').setValidators([Validators.required]);
      this.provisionalForm.get('LastRollNo').updateValueAndValidity();
      this.provisionalForm.get('EmMonth').setValidators([Validators.required]);
      this.provisionalForm.get('EmMonth').updateValueAndValidity();
      this.provisionalForm.get('EmYear').setValidators([Validators.required]);
      this.provisionalForm.get('EmYear').updateValueAndValidity();
      if (this.courseName == 'PHD') {
        this.provisionalForm.get('LastRollNo').clearValidators();
        this.provisionalForm.get('LastRollNo').clearValidators();
        this.provisionalForm.get('EmMonth').clearValidators;
        this.provisionalForm.get('EmMonth').clearValidators();
        this.provisionalForm.get('EmYear').clearValidators;
        this.provisionalForm.get('EmYear').clearValidators();
      }
     // this.provisionalForm.get('InternDate').setValidators([Validators.required]);
      this.provisionalForm.get('InternDate').updateValueAndValidity();
    }
    else if (data == 'OPC') {
      this.provisionalForm.controls["StuCertificate"].setValue(data);

      this.getOriginalPassCertificateData(this.StuId)
      this.provisionalForm.get('StuPRN').setValidators([Validators.required]);
      this.provisionalForm.get('StuPRN').updateValueAndValidity();
      this.provisionalForm.get('regnYear').setValidators([Validators.required]);
      this.provisionalForm.get('regnYear').updateValueAndValidity();
      this.provisionalForm.get('LastRollNo').setValidators([Validators.required]);
      this.provisionalForm.get('LastRollNo').updateValueAndValidity();
      this.provisionalForm.get('EmMonth').setValidators([Validators.required]);
      this.provisionalForm.get('EmMonth').updateValueAndValidity();
      this.provisionalForm.get('EmYear').setValidators([Validators.required]);
      this.provisionalForm.get('EmYear').updateValueAndValidity();

      //this.provisionalForm.get('Specialization').setValidators([Validators.required]);
      this.provisionalForm.get('Specialization').updateValueAndValidity();
    }
    else if (data == 'MC') {
      this.provisionalForm.controls["StuCertificate"].setValue(data);

      this.getMigrationCertificateData(this.StuId)
      this.provisionalForm.get('StuPRN').setValidators([Validators.required]);
      this.provisionalForm.get('StuPRN').updateValueAndValidity();
      this.provisionalForm.get('regnYear').setValidators([Validators.required]);
      this.provisionalForm.get('regnYear').updateValueAndValidity();
      this.provisionalForm.get('EmMonth').clearValidators();
      this.provisionalForm.get('EmMonth').updateValueAndValidity();
      this.provisionalForm.get('EmYear').clearValidators();
      this.provisionalForm.get('EmYear').updateValueAndValidity();
      this.provisionalForm.get('LastRollNo').clearValidators();
      this.provisionalForm.get('LastRollNo').updateValueAndValidity();
    }
    else if (data == 'RC') {
      this.provisionalForm.controls["StuCertificate"].setValue(data);

      this.getRankCertificateData(this.StuId)
      this.provisionalForm.get('LastRollNo').setValidators([Validators.required]);
      this.provisionalForm.get('LastRollNo').updateValueAndValidity();
      this.provisionalForm.get('EmMonth').setValidators([Validators.required]);
      this.provisionalForm.get('EmMonth').updateValueAndValidity();
      this.provisionalForm.get('EmYear').setValidators([Validators.required]);
      this.provisionalForm.get('EmYear').updateValueAndValidity();
      this.provisionalForm.get('InternDate').clearValidators();
      this.provisionalForm.get('InternDate').updateValueAndValidity();
      this.provisionalForm.get('StuPRN').clearValidators();
      this.provisionalForm.get('StuPRN').updateValueAndValidity();
      this.provisionalForm.get('regnYear').clearValidators();
      this.provisionalForm.get('regnYear').updateValueAndValidity();
    }
    else {
      this.provisionalForm.controls["StuCertificate"].setValue(data);
    }
  }


  onDrpChange(e) {
    this.provisionalForm.controls["UniDocName"].setValue(e.CdDesc);

  }

  getSecretData() {
    // this.spinner.show()
    this.calledApi++
    this.umsService.getSecretData().subscribe((res) => {
      if (res.status) {
        this.InstId = res.projectPharam['ClubPartTrans']
        this.internCourse = res.projectPharam['ActiveFlow']
        let data = []
        data = JSON.parse(this.internCourse)
        const courses = data[0].InternshipCourse.split(',');
        this.courses = courses
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }

    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide()
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }


  transPRN(RgNo) {
    this.formattedPrn = RgNo.toString().padStart(8, '0');
  }


  getProvisionalData(StuId: any) {
    this.SpecializationDrop = false
    this.Specialization = false
    this.calledApi++
    this.showInput = false
    let payload = {}
    payload['StuId'] = StuId
    this.umsService.GetProvisional(payload).subscribe(async (res) => {
      this.session = res?.data[0]?.SnNo
      if (res.status) {
        this.spinner.hide();
        this.SaveBtn = false;
        this.UpdateBtn = true;
        const data = res.data[0];
        this.updateId = data.ProvisionalId;
        this.CourseCoCode = data.CoCode;
         this.session = res.data[0].SnNo
        Object.keys(data).forEach(key => {
          if (key === "EmDate" && data[key]) {
            // Extract the year from "EmDate"
            const year = data[key].split(", ")[1];
            const month = data[key].split(", ")[0];
            this.onMonthSelect(month)
            // this.provisionalForm.controls['EmYear']?.setValue(year || ''); 
            this.onYearSelect(year);
          } else {
            if (res.data[0].InternDate) {
              this.internDate = res.data[0].InternDate
              this.showInput = true
            }
            else {
              this.showInput = false
            }
            if (res.data[0].CoCode == 'BSMLT') {

              this.Specialization = false
              this.SpecializationDrop = true

            }
            // else if (res.data[0].CoCode == 'BSMLT') {

            //   this.Specialization = false
            //   this.SpecializationDrop = true

            // }
            else if (res.data[0].Specialization) {

              this.Specialization = true
              this.SpecializationDrop = false
            }
            else {
              this.Specialization = false
              this.SpecializationDrop = false
            }

            if (res.data[0].Faculty) {
              this.isPhdCourseSelected = true;
            }
            else {
              this.isPhdCourseSelected = false;
            }
            if (res.data[0].PhdCompletionYear) {
              this.isPhdCourseSelected = true;
            }
            else {
              this.isPhdCourseSelected = false;
            }
            if (res.data[0].ThesisTitle) {
              this.isPhdCourseSelected = true;
            }
            else {
              this.isPhdCourseSelected = false;
            }
            this.provisionalForm.controls[key]?.setValue(data[key] || '');
          }

          if (res.data[0].CoCode === 'PHD') {
            this.isPhdCourseSelected = true;
            this.provisionalForm.get('Faculty').setValidators([Validators.required]);
            this.provisionalForm.get('PhdCompletionYear').setValidators([Validators.required]);
            this.provisionalForm.get('ThesisTitle').setValidators([Validators.required]);

            this.provisionalForm.get('LastInst').clearValidators();
            this.provisionalForm.get('LastRollNo').clearValidators();
            this.provisionalForm.get('EmMonth').clearValidators();
            this.provisionalForm.get('EmYear').clearValidators();

          } else {
            this.isPhdCourseSelected = false;
            this.provisionalForm.get('Faculty').clearValidators();
            this.provisionalForm.get('PhdCompletionYear').clearValidators();
            this.provisionalForm.get('ThesisTitle').clearValidators();

            this.provisionalForm.get('LastInst').setValidators([Validators.required]);
            this.provisionalForm.get('LastRollNo').setValidators([Validators.required]);
            this.provisionalForm.get('EmMonth').setValidators([Validators.required]);
            this.provisionalForm.get('EmYear').setValidators([Validators.required]);
          }
          this.provisionalForm.get('Faculty').updateValueAndValidity();
          this.provisionalForm.get('PhdCompletionYear').updateValueAndValidity();
          this.provisionalForm.get('ThesisTitle').updateValueAndValidity();

          this.provisionalForm.get('LastInst').updateValueAndValidity();
          this.provisionalForm.get('LastRollNo').updateValueAndValidity();
          this.provisionalForm.get('EmMonth').updateValueAndValidity();
          this.provisionalForm.get('EmYear').updateValueAndValidity();
        });
        this.onYearRegSelect(data.regnYear);
        this.onPhdYearSelect(data.PhdCompletionYear)
        this.getCertificateCourses(this.CourseCoCode)
        // Explicitly setting regnYear
        //this.StuId = this.StuId
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.GetTranscript(StuId);
        await this.getTclcData(StuId)
      }
      else {
        this.DocView = false;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.isdisabled = false;
        this.provisionalForm.reset()
        this.provisionalForm.controls["StuCertificate"].setValue('PC');
        this.PayFee = true;
        this.PayRecpt = false;
        this.Table = false;
        // this.finishedApi++;
        // if (this.finishedApi === this.calledApi) {
        //   this.spinner.hide();
        // }
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.getCourseData();
        // await this.GetTranscript(StuId);
        // await this.getTclcData(StuId)
      }

    },
      (ERROR: HttpErrorResponse) => {
        this.DocView = false;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.isdisabled = false;
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    )
  }

  getOriginalPassCertificateData(StuId: any) {
    this.SpecializationDrop = false
    this.Specialization = false
    this.calledApi++
    this.showInput = false
    let payload = { 'StuId': StuId };
    this.umsService.GetOriginalPassCertificate(payload).subscribe(async (res) => {
      if (res.status) {
        this.spinner.hide()
         this.session = res.data[0].SnNo
        this.SaveBtn = false;
        this.UpdateBtn = true;
        const data = res.data[0];
        // this.courseName = data['CoCode'];
        this.updateId = data.PassingId
        this.CourseCoCode = data.CoCode;
        Object.keys(data).forEach(key => {
          if (key === "EmDate" && data[key]) {
            // Extract the year from "EmDate"
            const year = data[key].split(", ")[1];
            const month = data[key].split(", ")[0];
            this.onMonthSelect(month)
            // this.provisionalForm.controls['EmYear']?.setValue(year || ''); 
            this.onYearSelect(year);
          } else {
            if (res.data[0].InternDate) {
              this.internDate = res.data[0].InternDate
              this.showInput = true
            }
            else {
              this.showInput = false
            }
            if (res.data[0].Specialization == 'Medical Laboratory Technology') {

              this.Specialization = false
              this.SpecializationDrop = true
            }
            else if (res.data[0].Specialization) {

              this.Specialization = true
              this.SpecializationDrop = false
            }
            else {
              this.Specialization = false
              this.SpecializationDrop = false
            }
            if (res.data[0].Faculty) {
              this.isPhdCourseSelected = true;
            }
            else {
              this.isPhdCourseSelected = false;
            }
            if (res.data[0].PhdCompletionYear) {
              this.isPhdCourseSelected = true;
            }
            else {
              this.isPhdCourseSelected = false;
            }
            if (res.data[0].ThesisTitle) {
              this.isPhdCourseSelected = true;
            }
            else {
              this.isPhdCourseSelected = false;
            }
            this.provisionalForm.controls[key]?.setValue(data[key] || '');
          }

          // if (this.courses.includes(data.CoCode)) {
          //   this.showInput = true
          // }
          // else {
          //   this.showInput = false
          // }

          if (res.data[0].CoCode === 'PHD') {
            this.isPhdCourseSelected = true;
            this.provisionalForm.get('Faculty').setValidators([Validators.required]);
            this.provisionalForm.get('PhdCompletionYear').setValidators([Validators.required]);
            this.provisionalForm.get('ThesisTitle').setValidators([Validators.required]);

            this.provisionalForm.get('LastInst').clearValidators();
            this.provisionalForm.get('LastRollNo').clearValidators();
            this.provisionalForm.get('EmMonth').clearValidators();
            this.provisionalForm.get('EmYear').clearValidators();

          } else {
            this.isPhdCourseSelected = false;
            this.provisionalForm.get('Faculty').clearValidators();
            this.provisionalForm.get('PhdCompletionYear').clearValidators();
            this.provisionalForm.get('ThesisTitle').clearValidators();

            this.provisionalForm.get('LastInst').setValidators([Validators.required]);
            this.provisionalForm.get('LastRollNo').setValidators([Validators.required]);
            this.provisionalForm.get('EmMonth').setValidators([Validators.required]);
            this.provisionalForm.get('EmYear').setValidators([Validators.required]);
          }
          this.provisionalForm.get('Faculty').updateValueAndValidity();
          this.provisionalForm.get('PhdCompletionYear').updateValueAndValidity();
          this.provisionalForm.get('ThesisTitle').updateValueAndValidity();

          this.provisionalForm.get('LastInst').updateValueAndValidity();
          this.provisionalForm.get('LastRollNo').updateValueAndValidity();
          this.provisionalForm.get('EmMonth').updateValueAndValidity();
          this.provisionalForm.get('EmYear').updateValueAndValidity();
        });
        this.onYearRegSelect(data.regnYear);
        this.onPhdYearSelect(data.PhdCompletionYear);
        this.getCertificateCourses(this.CourseCoCode)
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.GetTranscript(StuId);
        await this.getTclcData(StuId)
      }
      else {
        this.spinner.hide()
        this.DocView = false;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        // Object.keys(this.provisionalForm.controls).forEach(key => this.provisionalForm.controls[key]?.setValue(''));
        this.provisionalForm.reset()
        this.provisionalForm.controls["StuCertificate"].setValue('OPC');
        this.PayFee = false
        this.isdisabled = false;
        this.Table = false;
        // this.finishedApi++;
        // if (this.finishedApi === this.calledApi) {
        //   this.spinner.hide();
        // }
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.getCourseData();
        // await this.GetTranscript(StuId);
        // await this.getTclcData(StuId)
      }
      // this.StuId = this.StuId

    }, (ERROR: HttpErrorResponse) => {
      this.DocView = false;
      this.SaveBtn = true;
      this.UpdateBtn = false;
      this.isdisabled = false;
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  getMigrationCertificateData(StuId: any) {
    this.SpecializationDrop = false
    this.Specialization = false
    this.isPhdCourseSelected = false;
    this.calledApi++
    let payload = {}
    payload['StuId'] = StuId
    this.umsService.GetMigration(payload).subscribe(async (res) => {

      if (res.status) {
        this.SaveBtn = false;
         this.session = res.data[0].SnNo
        this.UpdateBtn = true;
        const data = res.data[0];
        // this.courseName = data['CoCode'];
        this.updateId = data.MigrationId
        Object.keys(data).forEach(key => {
          if (key === "EmDate" && data[key]) {
            // Extract the year from "EmDate"
            const year = data[key].split(", ")[1];
            const month = data[key].split(", ")[0];
            this.onMonthSelect(month)
            // this.provisionalForm.controls['EmYear']?.setValue(year || ''); 
            this.onYearSelect(year);
          } else {

            this.provisionalForm.controls[key]?.setValue(data[key] || '');
          }
        });
        this.onYearRegSelect(data.regnYear);
        this.getCertificateCourses(this.CourseCoCode)
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.GetTranscript(StuId);
        await this.getTclcData(StuId)
      }
      else {
        this.DocView = false;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.provisionalForm.reset()
        this.provisionalForm.controls["StuCertificate"].setValue('MC');
        this.PayFee = false
        this.PayRecpt = false
        this.Table = false;
        this.isdisabled = false;
        // this.finishedApi++;
        // if (this.finishedApi === this.calledApi) {
        //   this.spinner.hide();
        // }
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.getCourseData();
        // await this.GetTranscript(StuId);
        // await this.getTclcData(StuId)
      }
      // this.StuId = this.StuId


    }, (ERROR: HttpErrorResponse) => {
      this.DocView = false;
      this.SaveBtn = true;
      this.UpdateBtn = false;
      this.isdisabled = false;
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  getRankCertificateData(StuId: any) {
    this.SpecializationDrop = false
    this.Specialization = false
    this.isPhdCourseSelected = false;
    this.calledApi++
    let payload = {}
    payload['StuId'] = StuId
    this.umsService.GetRankCertificate(payload).subscribe(async (res) => {

      if (res.status) {
        this.SaveBtn = false;
        this.session = res.data[0].SnNo
        this.UpdateBtn = true;
        const data = res.data[0];
        // this.courseName = data['CoCode']; 
        this.updateId = data.RankId
        Object.keys(data).forEach(key => {
          if (key === "EmDate" && data[key]) {
            // Extract the year from "EmDate"
            const year = data[key].split(", ")[1];
            const month = data[key].split(", ")[0];
            this.onMonthSelect(month)
            // this.provisionalForm.controls['EmYear']?.setValue(year || ''); 
            this.onYearSelect(year);
          } else {

            this.provisionalForm.controls[key]?.setValue(data[key] || '');
          }
        });
        this.onYearRegSelect(data.regnYear);
        this.getCertificateCourses(this.CourseCoCode)
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.GetTranscript(StuId);
        await this.getTclcData(StuId)
      }
      else {
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.provisionalForm.reset()
        this.provisionalForm.controls["StuCertificate"].setValue('RC');
        this.PayFee = false
        this.PayRecpt = false
        this.DocView = false;
        this.isdisabled = false;
        this.Table = false;
        // this.finishedApi++;
        // if (this.finishedApi === this.calledApi) {
        //   this.spinner.hide();
        // }
        await this.GetTranscriptData(StuId)
        await this.getFilePathData(StuId)
        await this.getCourseData();
        // await this.getCourseData();
        // await this.GetTranscript(StuId);
        // await this.getTclcData(StuId)
      }

      // this.StuId = this.StuId


    }, (ERROR: HttpErrorResponse) => {
      this.DocView = false;
      this.SaveBtn = true;
      this.UpdateBtn = false;
      this.isdisabled = false;
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }


  GetTranscript(StuId) {

    // this.spinner.show()
    let payload = {};
    payload['StuId'] = StuId
    this.umsService.SearchTranscriptProvisional(payload).subscribe((res) => {

      if (res.status) {

        // this.spinner.hide()
        this.isdisabled = true;
        this.TranscriptData = res.data
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        // this.spinner.hide()
        this.isdisabled = false;
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  getCourseData() {
    // this.spinner.show()
    this.calledApi++
    const payload = {};
    payload['CertType'] = this.certType;
    this.umsService.getCertCourse(payload).subscribe(res => {

      if (res.status) {
        // this.spinner.hide()
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
      else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
    // this.filteredCourseList = this.courses.slice();
  }

  getTclcData(StuId) {
    this.spinner.show()
    const payload = {};
    // payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['SessionId'] = this.session;
    payload['CertType'] = this.certType
    payload['IsStudent'] = 1
    payload['StuId'] = StuId

    this.umsService.GetTclcData(payload).subscribe((res) => {
console.log('res.data',res.data)
      if (res.status) {
        this.spinner.hide()
        this.TclcData = res.data.filter(data => data.StuId == this.StuId)

        this.courseName = this.TclcData[0]['CoName']
        if (this.TclcData != '') {
          if (this.TclcData[0]['FeeStatus'] == 'Y') {
            this.PayFee = false;
            this.PayDisabled = true;
            this.PayRecpt = true;
            this.FeeStatus = this.TclcData[0]['FeeStatus'];
            this.spinner.hide();
          }
          else if (this.TclcData[0]['FeeStatus'] != 'Y') {
            this.PayFee = true;
            this.PayRecpt = false
            this.FeeStatus = ''
            this.ValidateFee(this.TclcData[0]['StuId'], this.TclcData[0]['CertType'], this.TclcData[0])
          }
          if (this.TclcData[0]['CertType'] == 'PC' || this.TclcData[0]['CertType'] == 'OPC' || this.TclcData[0]['CertType'] == 'MC' || this.TclcData[0]['CertType'] == 'RC') {

            this.isdisabled = true;
          }
          else if (this.TclcData[0]['CertType'] != 'PC' || this.TclcData[0]['CertType'] != 'OPC' || this.TclcData[0]['CertType'] != 'MC' || this.TclcData[0]['CertType'] != 'RC' && this.TclcData[0]['CertStatus'] == 'REJ') {

            this.SaveDisabled = false
            this.isdisabled = false;
            this.PayFee = false;
          }
          else {
            this.SaveDisabled = true;
            this.isdisabled = false;
          }

          switch (this.TclcData[0]['CertStatus']) {

            case "APR":
              if (this.TclcData[0]['CertType'] == "ADMC") {
                if (this.TclcData[0]['RgStatus'] == "L") {
                  this.Status = 'Application Approved'
                }
                else if (this.TclcData[0]['RgStatus'] == " ") {
                  this.Status = 'Application InProcess'
                }
              }
              else {
                this.Status = 'Approved';
              }
              this.UpdateDisabled = true;
              break;
            case "APPAP":
              if (this.TclcData[0]['CertType'] == "ADMC") {
                if (this.TclcData[0]['RgStatus'] == "L") {
                  this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
                  this.AdminUpload = this.AdminTclc[0]
                  this.Status = 'Application Approved'
                  this.showSoftCopy = true;
                }
                else if (this.TclcData[0]['RgStatus'] == " ") {
                  this.Status = 'Application InProcess'
                  this.showSoftCopy = false;
                }
              }
              else {
                this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
                this.AdminUpload = this.AdminTclc[0]
                this.Status = 'Application Approved'
                this.showSoftCopy = true;
              }
              this.UpdateDisabled = true;
              break;
            case "REJ":
              this.Status = 'Rejected'
              this.UpdateDisabled = true;
              this.showSoftCopy = false;
              this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
              this.AdminUpload = this.AdminTclc[0]
              break;
            case "REC":
              this.Status = 'Rectify';
              this.UpdateDisabled = false;
              this.showSoftCopy = false;
              this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
              this.AdminUpload = this.AdminTclc[0]
              break;
            case "Fees Paid":
              this.UpdateDisabled = true;
              this.Status = 'Fees Paid'
              this.showSoftCopy = false;
              this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
              this.AdminUpload = this.AdminTclc[0]
              break;
            case "ReSubmitted":
              this.Status = 'Re-Submitted'
              this.UpdateDisabled = false;
              // this.PayFee = true
              this.showSoftCopy = false;
              this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
              this.AdminUpload = this.AdminTclc[0]
              break;
            case "Submitted":
              this.Status = 'Submitted'
              this.UpdateDisabled = false;
              // this.PayFee = true
              this.showSoftCopy = false;
              this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
              this.AdminUpload = this.AdminTclc[0]
              break;
            case "UFD":
              this.Status = 'Certificate Generated'
              this.UpdateDisabled = true;
              this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
              this.AdminUpload = this.AdminTclc[0]
              break;
            default:
              this.UpdateDisabled = false;
              this.Status = this.TclcData[0]['CertStatus']
              this.AdminTclc = res.data.filter(data => data.StuId == this.StuId && data.CertType == this.certType)
              this.AdminUpload = this.AdminTclc[0]
              break
          }
          if (this.TclcData[0]['CertStatus'] == 'APR' && this.TclcData[0]['CertType'] != "ADMC") {
            this.Approved = true
            this.spinner.hide()
          }
          else {
            this.Approved = false
            this.spinner.hide()
          }
          this.Table = true
          this.TclcId = this.TclcData[0]['TclcId']
        }
        else {
          this.Table = false;
          this.DocView = false;
          this.isdisabled = false;
          //     this.finishedApi++
          // if (this.finishedApi === this.calledApi) {
          //   this.spinner.hide();
          // }
        }

        this.spinner.hide();
        // this.GetTranscriptData(StuId)
      }
      else {
        this.Table = false;
        this.PayFee = false;
        this.PayRecpt = false;
        this.DocView = false;
        this.isdisabled = false;
        // this.finishedApi++
        // if (this.finishedApi === this.calledApi) {
        //   this.spinner.hide();
        // }
        // this.GetTranscriptData(StuId)
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  GetTranscriptData(StuId) {
    this.calledApi++
    // this.spinner.show(); // Show the spinner at the beginning 
    const creds = this.provisionalForm.controls.arrData as FormArray;
    creds.clear();
    this.SaveDisabled = false;
    let payload = {};
    payload['SessionId'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = this.certType
    payload['StuId'] = StuId

    this.umsService.GetTcLcDocDetails(payload).subscribe(


      (res) => {
        if (res.status) {
          this.spinner.hide();
          // this.spinner.show()
          // this.TclcDocData = res.data.filter(record => record.StuId == StuId);
          // Filter only for this student
          let filteredData = res.data.filter(record => record.StuId == StuId);
          // Remove Ph.D. document if course is not PHD
          if (this.CourseCoCode !== 'PHD') {
            filteredData = filteredData.filter(record => record.DocName !== 'Ph.D Completion Certificate From University');
          }

          this.TclcDocData = filteredData;
          this.uploadedDoc = [];
          this.CommonDocument(StuId);
        } else {
          this.DocView = false;
          this.Table = false;
          this.PayFee = false;
          this.PayRecpt = false;
          this.isdisabled = false;
          this.CommonDocument(StuId);
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.DocView = false;
        this.isdisabled = false;
        console.error('Error occurred:', ERROR);
        // this.spinner.hide(); // Hide spinner if an error occurs
        this.cdr.detectChanges(); // Trigger change detection
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    );
  }



  CommonDocument(StuId) {
    this.DocTable = false;
    // this.spinner.show()
    this.DocView = false;
    let payload = {};
    payload['ModuleType'] = this.certType
    const creds = this.provisionalForm.controls.arrData as FormArray;
    creds.clear();
    this.umsService.CommonDocument(payload).subscribe((res) => {
      if (res.status) {

        this.isdisabled = false;
        const arrayOfObjects = res.data;
        this.spinner.show()
        arrayOfObjects.forEach((obj, i) => {
          const tempObj = {}
          let regex = '';
          if (obj.RegEx !== null) {
            regex = obj.RegEx
          }
          tempObj['DocumentName'] = new FormControl(obj.DocName),
            tempObj['SrNo'] = new FormControl(obj.SrNo),
            tempObj['docFile'] = new FormControl(''),
            tempObj['DocumentFile'] = new FormControl(''),
            tempObj['TclcDocId'] = new FormControl(''),
            tempObj['DocNo']= new FormControl(obj.DocNo),
            tempObj['filePath'] = new FormControl(obj.filePath),
            tempObj['isViewable'] = new FormControl(false);
            tempObj['IsChanged'] = new FormControl(false);
          for (const key in tempObj) {
          }
          const creds = this.provisionalForm.controls.arrData as FormArray;
          creds.push(new FormGroup(tempObj));
          const uploadedDoc = this.TclcDocData?.find( x => x.DocName === obj.DocName);
          if (uploadedDoc) {
            creds.at(i).patchValue({
              DocumentFile: uploadedDoc.FileUpload,
              TclcDocId: uploadedDoc.TclcDocId,
              filePath: uploadedDoc.FileUpload
            });
            this.uploadedDoc.push(uploadedDoc.DocName);
            this.umsService.fetchDocument({filePath: uploadedDoc.FileUpload,viewFile: true}).subscribe((docRes: any) => {
              creds.at(i).patchValue({
                isViewable: docRes.isViewable
              });
              this.allMandatoryUploaded = creds.controls.every((ctrl: any) => {

                const file = ctrl.get('DocumentFile')?.value;
                const isViewable = ctrl.get('isViewable')?.value;
                const isMandatory = ctrl.get('DocumentFile')?.errors?.required !== undefined
                  || ctrl.get('DocumentFile')?.hasError('required');

                console.log(
                  ctrl.get('DocumentName')?.value,
                  'file=', file,
                  'viewable=', isViewable,
                  'mandatory=', isMandatory
                );
                if (isMandatory && !file) {
                  return false;
                }
                if (file && isViewable !== true) {
                  return false;
                }
                return true;
              });
              this.PayFee = this.allMandatoryUploaded && !this.PayRecpt;
            });
          }
        })
        this.DocTable = true;
        this.spinner.hide();

      }
      else {
        this.DocTable = false
        this.spinner.hide();

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();

    })
  }


  course(item: any) {
    console.log(item);

    const internDateControl = this.provisionalForm.get('InternDate');
    const fatherNameControl = this.provisionalForm.get('StuFatherName');
    const motherNameControl = this.provisionalForm.get('StuMotherName');
    const specializationControl = this.provisionalForm.get('Specialization');


    if (this.certType !== 'PC' || this.certType !== 'OPC') {
      specializationControl.clearValidators();
      specializationControl.updateValueAndValidity();
    }

    this.Specialization = item.Specialization;
    this.CourseCode = item.CourseCode;
    this.Internship = item.Internship;
    this.CourseFullName = item.CourseCode
    if (this.certType === 'PC' || this.certType === 'OPC') {
      if (this.CourseFullName === 'PHD') {
        this.isPhdCourseSelected = true;
        this.provisionalForm.get('Faculty').setValidators([Validators.required]);
        this.provisionalForm.get('PhdCompletionYear').setValidators([Validators.required]);
        this.provisionalForm.get('ThesisTitle').setValidators([Validators.required]);

        this.provisionalForm.get('LastInst').clearValidators();
        this.provisionalForm.get('LastRollNo').clearValidators();
        this.provisionalForm.get('EmMonth').clearValidators();
        this.provisionalForm.get('EmYear').clearValidators();

      } else {
        this.isPhdCourseSelected = false;
        this.provisionalForm.get('Faculty').clearValidators();
        this.provisionalForm.get('PhdCompletionYear').clearValidators();
        this.provisionalForm.get('ThesisTitle').clearValidators();

        this.provisionalForm.get('LastInst').setValidators([Validators.required]);
        this.provisionalForm.get('LastRollNo').setValidators([Validators.required]);
        this.provisionalForm.get('EmMonth').setValidators([Validators.required]);
        this.provisionalForm.get('EmYear').setValidators([Validators.required]);
      }
      this.provisionalForm.get('Faculty').updateValueAndValidity();
      this.provisionalForm.get('PhdCompletionYear').updateValueAndValidity();
      this.provisionalForm.get('ThesisTitle').updateValueAndValidity();

      this.provisionalForm.get('LastInst').updateValueAndValidity();
      this.provisionalForm.get('LastRollNo').updateValueAndValidity();
      this.provisionalForm.get('EmMonth').updateValueAndValidity();
      this.provisionalForm.get('EmYear').updateValueAndValidity();

      const arrData = this.provisionalForm.get('arrData') as FormArray;

      if (this.CourseFullName !== 'PHD') {
        const indexToRemove = arrData.controls.findIndex(ctrl =>
          ctrl.get('DocumentName')?.value === 'Ph.D Completion Certificate From University'
        );

        if (indexToRemove !== -1) {
          arrData.removeAt(indexToRemove);
        }
      } else {
        // If course is PhD, ensure document is added
        const alreadyExists = arrData.controls.some(ctrl =>
          ctrl.get('DocumentName')?.value === 'Ph.D Completion Certificate From University'
        );

        if (!alreadyExists) {
          const phdDocGroup = new FormGroup({
            DocumentName: new FormControl('Ph.D Completion Certificate From University'),
            SrNo: new FormControl(arrData.length + 1),
            docFile: new FormControl(''),
            DocumentFile: new FormControl('', Validators.required),
            TclcDocId: new FormControl('')
          });
          this.applyValidatorsForCourse(phdDocGroup);
          arrData.push(phdDocGroup);
        }
      }
    }
    // if (this.CourseFullName === 'PHD') {
    //   const arrData = this.provisionalForm.get('arrData') as FormArray;

    //   const alreadyExists = arrData.controls.some(ctrl =>
    //     ctrl.get('DocumentName')?.value === 'Ph.D Completion Certificate From University'
    //   );

    //   if (!alreadyExists) {
    //     const phdDocGroup = new FormGroup({
    //       DocumentName: new FormControl('Ph.D Completion Certificate From University'),
    //       SrNo: new FormControl(arrData.length + 1),
    //       docFile: new FormControl(''),
    //       DocumentFile: new FormControl(''),
    //       TclcDocId: new FormControl('')
    //     });
    //     // this.applyValidatorsForCourse(phdDocGroup);
    //     arrData.push(phdDocGroup);
    //   }
    // }

    const documentFileControl = this.provisionalForm.get('arrData');

    if (this.certType === 'PC' || this.certType === 'OPC') {
      // InternDate validator
      // if (this.courses.includes(item.CdCode)) {
      //   internDateControl.setValidators([Validators.required]);
      //   internDateControl.markAsTouched();
      //   this.showInput = true;
      // } else {
      //   internDateControl.clearValidators();
      //   internDateControl.setValue('');
      //   this.showInput = false;
      // }
      // internDateControl.updateValueAndValidity();

      if (this.Internship) {
        internDateControl.setValidators([Validators.required]);
        internDateControl.markAsTouched();
        this.showInput = true;
        console.log('After setting internDateControl:', internDateControl);
      } else {
        internDateControl.clearValidators();
        internDateControl.setValue('');
        this.showInput = false;
      }
      internDateControl.updateValueAndValidity();


      if (item.CourseCode === 'BSMLT' || item.CourseCode === 'TWD') {
        this.Specialization = false;
        this.SpecializationDrop = true;
        if (specializationControl?.value == 'Medical Laboratory Technology' && this.internDate) {
          this.showInput = true;
          this.provisionalForm.get('InternDate')?.setValue(this.internDate);
        } else {
          this.showInput = false;
        }
        specializationControl?.setValidators([Validators.required]);
        specializationControl?.markAsTouched();
        specializationControl?.updateValueAndValidity();

        // If value exists in specializationControl, show the input
        // if (specializationControl?.value && (this.certType === 'OPC' || this.certType === 'PC')) {
        //   this.showInput = true;
        //   this.provisionalForm.get('InternDate')?.setValue(this.internDate);
        // } else {
        //   this.showInput = false;
        // }
      }

      else if (this.Specialization) {

        this.Specialization = true;
        this.SpecializationDrop = false;

        // specializationControl.reset(); // Reset value & state
        specializationControl.setValidators([Validators.required]);
        specializationControl.markAsTouched(); // Optional: shows validation error immediately
        specializationControl.setValue(null);
        specializationControl.updateValueAndValidity();

        console.log('After setting validator:', specializationControl);
      } else {
        this.Specialization = false;
        this.SpecializationDrop = false;

        specializationControl.clearValidators();
        specializationControl.updateValueAndValidity();
      }

      // if (['BSMLT'].includes(this.CourseCode)) {
      //   this.Specialization = false;
      //   this.SpecializationDrop = true
      //   specializationControl.setValidators([Validators.required]);

      //   specializationControl.markAsTouched();
      // } else {
      //   this.Specialization = false
      //   this.SpecializationDrop = false
      //   specializationControl.clearValidators();
      //   specializationControl.setValue('');
      // }
      // specializationControl.updateValueAndValidity();


      if (['BAMSA', 'MSA', 'MDA'].includes(this.CourseCode)) {
        fatherNameControl.setValidators([Validators.required]);
        fatherNameControl.markAsTouched();
        fatherNameControl.updateValueAndValidity();

        motherNameControl.setValidators([Validators.required]);
        motherNameControl.markAsTouched();
        motherNameControl.updateValueAndValidity();

        // specializationControl.setValidators([Validators.required]);
        // specializationControl.markAsTouched();
        // specializationControl.updateValueAndValidity();
      }
      else {
        fatherNameControl.clearValidators();
        fatherNameControl.updateValueAndValidity();

        motherNameControl.clearValidators();
        motherNameControl.updateValueAndValidity();

        // specializationControl.clearValidators();
        // specializationControl.updateValueAndValidity();
      }
    }
    else {
      this.Specialization = false
    }
  }
  // course(item: any) {
  //   const internDateControl = this.provisionalForm.get('InternDate');
  //   const fatherNameControl = this.provisionalForm.get('StuFatherName');
  //   const motherNameControl = this.provisionalForm.get('StuMotherName');
  //   const specializationControl = this.provisionalForm.get('Specialization');

  //   this.Specialization = item.Specialization;
  //   this.CourseCode = item.CourseCode;
  //   this.Internship = item.Internship;
  //   this.CourseFullName = item.CourseCode;

  //   const arrData = this.provisionalForm.get('arrData') as FormArray;

  //   if (this.CourseFullName === 'PHD') {
  //     this.isPhdCourseSelected = true;
  //     this.provisionalForm.get('Faculty')?.setValidators([Validators.required]);
  //     this.provisionalForm.get('PhdCompletionYear')?.setValidators([Validators.required]);
  //     this.provisionalForm.get('ThesisTitle')?.setValidators([Validators.required]);

  //     // Add Ph.D certificate if not present
  //     const alreadyExists = arrData.controls.some(ctrl =>
  //       ctrl.get('DocumentName')?.value === 'Ph.D Completion Certificate From University'
  //     );

  //     if (!alreadyExists) {
  //       const phdDocGroup = new FormGroup({
  //         DocumentName: new FormControl('Ph.D Completion Certificate From University'),
  //         SrNo: new FormControl(arrData.length + 1),
  //         docFile: new FormControl(''),
  //         DocumentFile: new FormControl('', Validators.required),
  //         TclcDocId: new FormControl('')
  //       });
  //       this.applyValidatorsForCourse(phdDocGroup);
  //       arrData.push(phdDocGroup);
  //     }

  //   } else {
  //     this.isPhdCourseSelected = false;
  //     this.provisionalForm.get('Faculty')?.clearValidators();
  //     this.provisionalForm.get('PhdCompletionYear')?.clearValidators();
  //     this.provisionalForm.get('ThesisTitle')?.clearValidators();

  //     // ✅ Simple logic to remove the PhD doc
  //     for (let i = 0; i < arrData.length; i++) {
  //       const docName = arrData.at(i).get('DocumentName')?.value;
  //       if (docName === 'Ph.D Completion Certificate From University') {
  //         arrData.removeAt(i);
  //         break;
  //       }
  //     }
  //   }

  //   // Update all validators
  //   this.provisionalForm.get('Faculty')?.updateValueAndValidity();
  //   this.provisionalForm.get('PhdCompletionYear')?.updateValueAndValidity();
  //   this.provisionalForm.get('ThesisTitle')?.updateValueAndValidity();

  //   // Internship logic
  //   if (this.certType === 'PC' || this.certType === 'OPC') {
  //     if (this.Internship) {
  //       internDateControl?.setValidators([Validators.required]);
  //       internDateControl?.markAsTouched();
  //       this.showInput = true;
  //     } else {
  //       internDateControl?.clearValidators();
  //       internDateControl?.setValue('');
  //       this.showInput = false;
  //     }
  //     internDateControl?.updateValueAndValidity();

  //     // Specialization logic
  //     if (this.Specialization) {
  //       specializationControl?.setValidators([Validators.required]);
  //       specializationControl?.markAsTouched();
  //     } else {
  //       specializationControl?.clearValidators();
  //       specializationControl?.setValue('');
  //     }
  //     specializationControl?.updateValueAndValidity();

  //     // Parent name validators for specific courses
  //     if (['BAMSA', 'MSA', 'MDA'].includes(this.CourseCode)) {
  //       fatherNameControl?.setValidators([Validators.required]);
  //       fatherNameControl?.markAsTouched();
  //       motherNameControl?.setValidators([Validators.required]);
  //       motherNameControl?.markAsTouched();
  //     } else {
  //       fatherNameControl?.clearValidators();
  //       motherNameControl?.clearValidators();
  //     }
  //     fatherNameControl?.updateValueAndValidity();
  //     motherNameControl?.updateValueAndValidity();
  //   } else {
  //     this.Specialization = false;
  //   }
  // }


  Save() {

    this.saveClicked = true;

    // Apply validators for the course field and other dynamic fields
    const creds = this.provisionalForm.get('arrData') as FormArray;
    creds.controls.forEach(element => {
      this.applyValidatorsForCourse(element);  // Apply the correct validators based on the course
    });

    if (this.provisionalForm.get('declaration').value) {
      const creds = this.provisionalForm.get('arrData') as FormArray;
      let allDocumentsValid = true;
      let allValid = true;

      // Clear and reset all validators based on course change
      creds.controls.forEach(element => {
        this.applyValidatorsForCourse(element);  // Apply the correct validators
      });

      // Check the form validity
      if (this.provisionalForm.invalid) {
        this.markFormFieldsAsTouched();
        allValid = false;
      } else {
        allValid = true;
      }

      if (allDocumentsValid && allValid) {
        this.Submit(); // Proceed with save if everything is valid
      } else {
        // Handle the case where validation fails
      }
    } else {
      // Handle the case where 'declaration' is not true
      const creds = this.provisionalForm.get('arrData') as FormArray;
      let allDocumentsValid = true;
      let allValid = true;

      creds.controls.forEach(element => {
        this.applyValidatorsForCourse(element);  // Apply the correct validators
      });

      // Same validation check
      if (this.provisionalForm.invalid) {
        this.markFormFieldsAsTouched();
        allValid = false;
      } else {
        allValid = true;
      }
    }
  }

  // Function to apply course-specific validators
  applyValidatorsForCourse(element: AbstractControl) {
    const documentFileValue = element.get('DocumentFile').value;
    const documentNameValue = element.get('DocumentName').value;
    const code = this.provisionalForm.get('CoCode').value;
    const arrData = this.provisionalForm.get('arrData') as FormArray;



    // Apply course-specific logic for validators
    if (!documentFileValue || documentFileValue === '') {
      if (documentNameValue === 'Bond Period Completion Certificate/NOC from DME, Assam.(wherever applicable)') {
        element.get('DocumentFile').clearValidators(); // Clear validators
        element.get('DocumentFile').setValue(''); // Clear the value
      } else {
        element.get('DocumentFile').setValidators([Validators.required]); // Add required validator
        element.get('DocumentFile').markAsTouched();
      }
      element.get('DocumentFile').updateValueAndValidity(); // Update the form control status
    }

    // Special logic based on CoCode
    if (!documentFileValue || documentFileValue === '') {
      if (this.Internship) {
        if (documentNameValue === 'Internship completion certificate(wherever applicable)') {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').markAsTouched();
        }
        else if (documentNameValue !== 'Bond Period Completion Certificate/NOC from DME, Assam.(wherever applicable)') {
          element.get('DocumentFile').setValidators([Validators.required]);
          element.get('DocumentFile').markAsTouched();
        }
      } else if (documentNameValue === 'Internship completion certificate(wherever applicable)') {
        element.get('DocumentFile').clearValidators();
        element.get('DocumentFile').setValue(''); // Clear value for invalid code
      }
    }

    if (this.specItem === 'Medical Laboratory Technology') {


      if (documentNameValue === 'Internship completion certificate(wherever applicable)') {
        element.get('DocumentFile').setValidators([Validators.required]);
        element.get('DocumentFile').markAsTouched();
      }
      element.get('DocumentFile').updateValueAndValidity();
    }

    if (documentNameValue === 'Ph.D Completion Certificate From University') {
      if (this.CourseFullName === 'PHD') {
        element.get('DocumentFile').setValidators([Validators.required]);
        element.get('DocumentFile').markAsTouched();
      } else {
        element.get('DocumentFile').clearValidators();
        element.get('DocumentFile').setValue(''); // Clear value for invalid code
      }
      element.get('DocumentFile').updateValueAndValidity(); // Update the form control status
    }

    if (documentNameValue === 'Pass Certificate issued from respective College/Institute') {
      if (this.CourseFullName === 'PHD') {
        element.get('DocumentFile').clearValidators();
        element.get('DocumentFile').setValue(''); // Clear value for invalid code
      } else {
        element.get('DocumentFile').setValidators([Validators.required]);
        element.get('DocumentFile').markAsTouched();
      }
      element.get('DocumentFile').updateValueAndValidity(); // Update the form control status
    }

    if (documentNameValue === 'All marksheets of the concerned examinations') {
      if (this.CourseFullName === 'PHD') {
        element.get('DocumentFile').clearValidators();
        element.get('DocumentFile').setValue(''); // Clear value for invalid code
      } else {
        element.get('DocumentFile').setValidators([Validators.required]);
        element.get('DocumentFile').markAsTouched();
      }
      element.get('DocumentFile').updateValueAndValidity(); // Update the form control status
    }


    // if (!documentFileValue || documentFileValue === '') {
    //   if(this.CourseFullName === 'PHD'){
    //     if (documentNameValue === 'Ph.D Completion Certificate From University') {
    //       element.get('DocumentFile').clearValidators(); // Clear validators
    //       element.get('DocumentFile').setValue(''); // Clear the value
    //     } else {
    //       element.get('DocumentFile').setValidators([Validators.required]); // Add required validator
    //       element.get('DocumentFile').markAsTouched();
    //     }
    //   } else {
    //       element.get('DocumentFile').clearValidators(); // Clear validators
    //       element.get('DocumentFile').setValue(''); // Clear the value
    //   }

    // }
  }

  // Function to mark all necessary form fields as touched
  markFormFieldsAsTouched() {
    const certificateType = this.provisionalForm.value['StuCertificate'];
    if (certificateType === 'PC' || certificateType === 'OPC' || certificateType === 'MC' || certificateType === 'RC') {
      this.provisionalForm.get('StuName').markAsTouched();
      this.provisionalForm.get('CoCode').markAsTouched();
      this.provisionalForm.get('LastInst').markAsTouched();
      this.provisionalForm.get('EmailId').markAsTouched();
      this.provisionalForm.get('StuPRN').markAsTouched();
      this.provisionalForm.get('regnYear').markAsTouched();
      this.provisionalForm.get('LastRollNo').markAsTouched();
      this.provisionalForm.get('EmMonth').markAsTouched();
      this.provisionalForm.get('EmYear').markAsTouched();

      if (certificateType === 'OPC') {
        this.provisionalForm.get('Specialization').markAsTouched();
      }
      if (this.isPhdCourseSelected) {
        this.provisionalForm.get('Faculty').markAsTouched();
        this.provisionalForm.get('PhdCompletionYear').markAsTouched();
        this.provisionalForm.get('ThesisTitle').markAsTouched();
      }
    }
  }


  Submit() {


    this.spinner.show();
    if (this.certType == 'PC' || this.certType == 'OPC' || this.certType == 'MC' || this.certType == 'RC') {
      // Check if InternDate exists in the form value
      if (this.provisionalForm.value['InternDate']) {
        let formattedDob = formatDate(this.provisionalForm.value['InternDate'], 'yyyy-MM-dd', 'en'); // Converts to '1993-01-07'
        this.provisionalForm.patchValue({ InternDate: formattedDob }); // Update before sending
      } else {
        this.provisionalForm.patchValue({ InternDate: null });
      }
    }
    const submitpayload = this.provisionalForm.value;
    const month = this.ExamMonth || "UnknownMonth";
    const concatenatedDate = submitpayload.EmYear ? `${month}, ${submitpayload.EmYear}` : null;
    const payload = {}
    payload['StuId'] = this.StuId,
      payload['FeeStatus'] = '',
      payload['CertType'] = this.certType,
      payload['CertStatus'] = 'Submitted',
      payload['StatusBy'] = sessionStorage.getItem('loginId'),
      payload['DocStatus'] = 'Y',
      payload['Comment'] = '',
      payload['StuName'] = submitpayload.StuName,
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['StuPRN'] = submitpayload.StuPRN,
      payload['StuAdd'] = submitpayload.StuAdd,
      payload['StuPhone'] = submitpayload.StuPhone,
      payload['CertName'] = this.certType,
      payload['StuFatherName'] = submitpayload.StuFatherName,
      payload['StuMotherName'] = submitpayload.StuMotherName,
      payload['LastInst'] = submitpayload.LastInst,
      payload['LastRollNo'] = submitpayload.LastRollNo ? submitpayload.LastRollNo : null,
      payload['LastExam'] = submitpayload.LastExam,
      payload['CoCode'] = submitpayload.CoCode,
      payload['EmailId'] = submitpayload.EmailId
    payload['EmMonth'] = submitpayload.EmMonth ? submitpayload.EmMonth : null
    payload['regnYear'] = submitpayload.regnYear.toString()
    // payload['Faculty'] = submitpayload.Faculty,
    // payload['PhdCompletionYear'] = submitpayload.PhdCompletionYear.toString(),
    // payload['ThesisTitle'] = submitpayload.ThesisTitle
    // Include PhD-specific fields if course is PhD
    if (this.CourseFullName === 'PHD') {
      payload['Faculty'] = submitpayload.Faculty;
      payload['PhdCompletionYear'] = submitpayload.PhdCompletionYear?.toString();
      payload['ThesisTitle'] = submitpayload.ThesisTitle;
    }
    // Conditionally call services based on CertType
    if (this.certType === 'PC') {
      payload['HardCopy'] = submitpayload.HardCopy
      payload['EmDate'] = concatenatedDate ? concatenatedDate : null
      payload['InternDate'] = submitpayload.InternDate
      payload['Specialization'] = submitpayload.Specialization

      this.umsService.AddProvisional(payload).subscribe(
        (res) => this.handleResponse(res),
        (ERROR: HttpErrorResponse) => this.handleError(ERROR.error.message)
      );
    }

    if (this.certType === 'OPC') {
      payload['HardCopy'] = submitpayload.HardCopy
      payload['EmDate'] = concatenatedDate ? concatenatedDate : null
      payload['InternDate'] = submitpayload.InternDate
      payload['Specialization'] = submitpayload.Specialization
      this.umsService.AddOriginalPassing(payload).subscribe(
        (res) => this.handleResponse(res),
        (ERROR: HttpErrorResponse) => this.handleError(ERROR.error.message)
      );
    }

    if (this.certType === 'MC') {
      payload['HardCopy'] = submitpayload.HardCopy

      this.umsService.AddMigration(payload).subscribe(
        (res) => this.handleResponse(res),
        (ERROR: HttpErrorResponse) => this.handleError(ERROR.error.message)
      );
    }

    if (this.certType === 'RC') {

      payload['HardCopy'] = submitpayload.HardCopy
      payload['EmDate'] = concatenatedDate ? concatenatedDate : null,
        payload['StuRank'] = submitpayload.StuRank
      payload['TotalCandidate'] = submitpayload.TotalCandidate
      this.umsService.AddRank(payload).subscribe(
        (res) => this.handleResponse(res),
        (ERROR: HttpErrorResponse) => this.handleError(ERROR.error.message)
      );
    }
  }

  handleResponse(res: any) {
    if (res.status) {
      this.SubmitTclc();
    } else {
      this.handleError(res.message);
    }
  }

  handleError(message: string) {
    this.spinner.hide();
    const data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  }



  SubmitTclc() {
    const submitpayload = this.provisionalForm.value
    let payload = {}
    payload['StuFaculty'] = '',
      payload['StuCourse'] = submitpayload.CoCode,
      payload['StuCollege'] = '',
      payload['StuExam'] = '',
      payload['StuBranch'] = '',
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = this.certType,
      payload['DestClg'] = '',
      payload['Reason'] = '',
      payload['Other'] = '',
      payload['FeeStatus'] = '';
    payload['CertStatus'] = 'Submitted';
    payload['StuId'] = this.StuId;
    payload['Comment'] = '';
    payload['CertScr'] = '';
    payload['StatusBy'] = sessionStorage.getItem('loginId');
    payload['DocStatus'] = 'Y';
    payload['StuEmail'] = '';
    payload['Copy'] = '';
    payload['Certificate'] = '';
    this.umsService.AddTclc(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.AddTclcDoc()
        this.saveFiles()
         this.saveFiles1()
        // let data = {}
        // data['message'] = "Submitted Successfully"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   // this.SaveDisabled = true;
        //   this.ShowGrid()
        // });

      }
      else {
        this.spinner.hide()
        let data = {}
        data['title'] = 'Alert'
      } (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
          AlertboxComponent,
          data
        );
      }
    })
  }

  AddTclcDoc() {
    const submitpayload = this.provisionalForm.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.provisionalForm.controls.arrData.value.forEach((element, index, array) => {
        console.log("element",element);
      })
      this.provisionalForm.controls.arrData.value.forEach((element, index, array) => {
        let payload = {};
        payload['StuId'] = this.StuId,
          payload['CertType'] = this.certType,
          payload['DocName'] = element.DocumentName;
           const match = this.filePathData.find(x => x.DocNo === element.DocNo);

if (!match || !match.filePath) {
  console.error("filePath missing:", element);
  return;
}
          payload['FileUpload'] = match.filePath + '.pdf';
          payload['SrNo'] = element.SrNo
          payload['DocNo']=element.DocNo
            if (!this.fileUploads[index]) return;
        setTimeout(() => {
          this.umsService.AddTclcDoc(payload).subscribe(res => {
            // this.spinner.hide();
            if (res.status == false) {
              // this.spinner.hide()
              iserror = true;
              this.errMsg = res.message;
            } else {
              // this.spinner.hide()
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            // this.fetchDocument();
            this.fileUploader.nativeElement.value = null;
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      // this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();

        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ShowGrid()
          // this.GetTranscript(this.StuId)
          this.ShowTable(this.certType)

        });
        this.saveApplicationDetails();
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ShowGrid()
        });
      }
    });

  }

  saveApplicationDetails() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StuId;
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'))
    payload['CgCode'] = this.provisionalForm.value['StuClg']
    payload['CoCode'] = this.provisionalForm.value['StuCourse']
    payload['ApplicationName'] = this.certType
    payload['ApplicationSubDate'] = formattedDate
    this.umsService.saveApplicationDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    })
  }

  Update(validate=false) {
    this.saveClicked = true;
    this.provisionalForm.get('declaration').setValue(true);

    // Format InternDate only if certType is PC or OPC
    if (this.certType === 'PC' || this.certType === 'OPC') {
      let internDate = this.provisionalForm.get('InternDate')?.value;
      let spec = this.provisionalForm.get('Specialization')?.value;

      if (internDate && internDate !== 'Invalid Date') {
        const formattedDob = formatDate(internDate, 'yyyy-MM-dd', 'en');
        this.provisionalForm.patchValue({ InternDate: formattedDob });
      } else {
        this.provisionalForm.patchValue({ InternDate: null });
        this.provisionalForm.get('InternDate').clearValidators()
        // OR force update:
        // this.provisionalForm.get('InternDate')?.setValue(null);
      }

      if (spec && spec !== '') {
        this.provisionalForm.patchValue({ Specialization: spec });
      } else {
        this.provisionalForm.patchValue({ Specialization: null });
        this.provisionalForm.get('Specialization').clearValidators()
        // OR force update:
        // this.provisionalForm.get('InternDate')?.setValue(null);
      }

    }

    const courseCodeControl = this.provisionalForm.get('CoCode');
    const fatherNameControl = this.provisionalForm.get('StuFatherName');
    const motherNameControl = this.provisionalForm.get('StuMotherName');
    const courseCode = courseCodeControl?.value;

    if (['BAMSA', 'MSA', 'MDA'].includes(courseCode)) {
      fatherNameControl.setValidators([Validators.required]);
      fatherNameControl.markAsTouched();
      fatherNameControl.updateValueAndValidity();

      motherNameControl.setValidators([Validators.required]);
      motherNameControl.markAsTouched();
      motherNameControl.updateValueAndValidity();

      // specializationControl.setValidators([Validators.required]);
      // specializationControl.markAsTouched();
      // specializationControl.updateValueAndValidity();
    } else {
      fatherNameControl.clearValidators();
      fatherNameControl.updateValueAndValidity();

      motherNameControl.clearValidators();
      motherNameControl.updateValueAndValidity();

      // specializationControl.clearValidators();
      // specializationControl.updateValueAndValidity();
    }

    // Apply validators for course-based fields
    const creds = this.provisionalForm.get('arrData') as FormArray;

    creds.controls.forEach(element => {
      this.applyValidatorsForCourse(element);  // Dynamic field validation
    });

    // Ensure validators are updated
    this.provisionalForm.updateValueAndValidity();

    // 👇 VALIDATION BLOCK - prevent update if form is invalid

    if (this.provisionalForm.invalid) {
       this.PayFee =false;
      this.markFormFieldsAsTouched();  // Show validation errors
      return; // 💥 Stop the function here if the form is not valid
    }
    if(validate && creds.valid && this.allMandatoryUploaded){
      this.PayFee =true;
      this.PayRecpt=false
    }else{
      this.PayFee =false;
    }

    // Declaration checkbox check
    if (!this.provisionalForm.get('declaration').value) {
      return;
    }

    this.spinner.show();

    const submitpayload = this.provisionalForm.value;
    const month = this.ExamMonth || "UnknownMonth";
    const concatenatedDate = submitpayload.EmYear ? `${month}, ${submitpayload.EmYear}` : null;
    let payload = {};

    // Assign payload based on certType
    switch (this.certType) {
      case 'PC':
        payload = {
          ProvisionalId: this.updateId,
          HardCopy: submitpayload.HardCopy,
          EmDate: concatenatedDate ? concatenatedDate : null,
          InternDate: submitpayload.InternDate,
          Specialization: submitpayload.Specialization,
        };
        break;

      case 'OPC':
        payload = {
          PassingId: this.updateId,
          HardCopy: submitpayload.HardCopy,
          EmDate: concatenatedDate ? concatenatedDate : null,
          InternDate: submitpayload.InternDate,
          Specialization: submitpayload.Specialization,
        };
        break;

      case 'MC':
        payload = {
          MigrationId: this.updateId,
          HardCopy: submitpayload.HardCopy,
        };
        break;

      case 'RC':
        payload = {
          RankId: this.updateId,
          HardCopy: submitpayload.HardCopy,
          EmDate: concatenatedDate ? concatenatedDate : null,
          StuRank: submitpayload.StuRank,
          TotalCandidate: submitpayload.TotalCandidate,
        };
        break;
    }

    // Common payload fields
    Object.assign(payload, {
      StuId: this.StuId,
      FeeStatus: '',
      CertType: this.certType,
      CertStatus: 'Submitted',
      StatusBy: sessionStorage.getItem('loginId'),
      DocStatus: 'Y',
      Comment: '',
      StuName: submitpayload.StuName,
      SnNo: parseInt(sessionStorage.getItem('session')),
      StuPRN: submitpayload.StuPRN,
      StuAdd: submitpayload.StuAdd,
      StuPhone: submitpayload.StuPhone,
      CertName: this.certType,
      StuFatherName: submitpayload.StuFatherName,
      StuMotherName: submitpayload.StuMotherName,
      LastInst: submitpayload.LastInst,
      LastRollNo: submitpayload.LastRollNo,
      LastExam: submitpayload.LastExam,
      CoCode: submitpayload.CoCode,
      EmailId: submitpayload.EmailId,
      ProvisionalId: submitpayload.ProvisionalId,
      regnYear: submitpayload.regnYear.toString(),
      EmMonth: submitpayload.EmMonth,
      InternDate: submitpayload.InternDate,
      HardCopy: submitpayload.HardCopy,
      ...(this.CourseFullName === 'PHD' && {
        Faculty: submitpayload.Faculty,
        PhdCompletionYear: submitpayload.PhdCompletionYear?.toString(),
        ThesisTitle: submitpayload.ThesisTitle,
      })
      // Faculty: submitpayload.Faculty,
      // PhdCompletionYear: submitpayload.PhdCompletionYear.toString(),
      // ThesisTitle: submitpayload.ThesisTitle
    });

    // Call appropriate update service
    switch (this.certType) {
      case 'PC':
        this.umsService.UpdateProvisional(payload).subscribe(
          res => this.handleUpdateResponse(res),
          (err: HttpErrorResponse) => this.handleError(err.error.message)
        );
        break;

      case 'OPC':
        this.umsService.UpdateOriginalPassing(payload).subscribe(
          res => this.handleUpdateResponse(res),
          (err: HttpErrorResponse) => this.handleError(err.error.message)
        );
        break;

      case 'MC':
        this.umsService.UpdateMigration(payload).subscribe(
          res => this.handleUpdateResponse(res),
          (err: HttpErrorResponse) => this.handleError(err.error.message)
        );
        break;

      case 'RC':
        this.umsService.UpdateRank(payload).subscribe(
          res => this.handleUpdateResponse(res),
          (err: HttpErrorResponse) => this.handleError(err.error.message)
        );
        break;
    }
  }

  handleUpdateResponse(res: any) {
    if (res.status) {
      this.UpdateTclc();
    } else {
      this.handleError(res.message);
    }
  }

  handleUpdateError(message: string) {
    this.spinner.hide();
    const data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  }

  UpdateTclc() {
    const submitpayload = this.provisionalForm.value
    let payload = {}
    payload['StuFaculty'] = '',
      payload['StuCourse'] = submitpayload.CoCode,
      payload['StuCollege'] = submitpayload.StuClg,
      payload['StuExam'] = '',
      payload['StuBranch'] = '',
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = this.certType,
      payload['DestClg'] = '',
      payload['Reason'] = '',
      payload['Other'] = '',
      payload['FeeStatus'] = this.FeeStatus;
    payload['CertStatus'] = 'ReSubmitted';
    payload['StuId'] = this.StuId;
    payload['Comment'] = '';
    payload['CertScr'] = '';
    payload['StatusBy'] = sessionStorage.getItem('loginId');
    payload['DocStatus'] = 'Y';
    payload['TclcId'] = this.TclcId,
      payload['StuEmail'] = '';
    payload['Copy'] = '';
    payload['Certificate'] = '';
    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.hide()
        this.UpdateTclcDoc()
        // let data = {}
        // data['message'] = "Updated Successfully"
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        // // this.SaveDisabled = true;
        // this.ShowGrid();
      }
      else {
        this.spinner.hide()
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    })
  }

  UpdateTclcDoc() {
    const submitpayload = this.provisionalForm.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      const docsToSave = this.provisionalForm.controls.arrData.value.filter((element: any) =>
  element.TclcDocId || element.DocumentFile
);
      docsToSave.forEach((element, index, array) => {
        let srno = index + 1
        let payload = {};
        payload['StuId'] = this.StuId,
          payload['CertType'] = this.certType,
          payload['DocName'] = element.DocumentName;
          const match = this.filePathData.find(x => x.DocNo === element.DocNo);
          if(match){
            payload['FileUpload'] = match.filePath + '.pdf'
          }else{
            payload['FileUpload'] =element.DocumentFile;
          }
        payload['TclcDocId'] = element.TclcDocId,
          payload['SrNo'] = srno
        setTimeout(() => {
          this.umsService.UpdateTclcDoc(payload).subscribe(res => {
            // this.spinner.hide();
            if (res.status == false) {
              // this.spinner.hide()
              iserror = true;
              this.errMsg = res.message;
            } else {
              // this.spinner.hide()
              iserror = false;
              this.errMsg = res.message;
            }
            if (index === array.length - 1) resolve();
            // this.fetchDocument();
            if (this.fileUploader != undefined) {
              this.fileUploader.nativeElement.value = null;
            }

          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide()
            iserror = true;
            this.errMsg = ERROR.error.message;
            if (index === array.length - 1) resolve();
          });
        }, index * 2000);
      });

    })
    bar.then(() => {
      // this.spinner.hide();
      if (iserror == false) {
        this.spinner.hide();
        // this.saveApplicationDetails();
          this.saveFiles();
          this.saveFiles1();
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.GetTranscript(this.StuId)
          this.ShowTable(this.certType)
          // this.ShowGrid()
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ShowGrid()
        });
      }
    });

  }







  PayFees() {
    const Data = this.provisionalForm.value
    this.Tclcdata.push({
      "StuCourse": Data.StuCourse,
      "StuClg": Data.StuClg,
      "SnNo": parseInt(sessionStorage.getItem('session')),
      "CertType": this.certType,
      "StuName": Data.StuName,
      "MotherName": Data.StuMotherName,
      "FatherName": Data.FatherName,
      "Mobile": Data.StuPhone,
      "StuPRN": Data.StuPRN,
      "StuId": this.StuId
    })
    this.umsService.setTclcData(this.Tclcdata);
    this.redirect('TCLCFees')
  }

  TypeUni() {
    if (this.provisionalForm.value['DestCollege'] == 'Other') {
      this.Other = true;
    }
    else {
      this.Other = false;
    }
  }

  getFeeTempData() {
    this.spinner.show();
    const payload = {};
    payload['FeeType'] = this.certType
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      if (res.status) {
        this.addnewrecord(res.data[0]['TemplateCode'])
      }
    })
  }

  addnewrecord(TempCode) {

    let data = {};
    data['SnNo'] = this.provisionalForm.value['SnNo']
    data['TemplateCode'] = TempCode;
    data['FeeType'] = this.certType
    data['StuName'] = this.provisionalForm.value['StuName']
    data['MotherName'] = this.provisionalForm.value['StuMotherName']
    data['FatherName'] = this.provisionalForm.value['StuFatherName']
    data['Mobile'] = this.provisionalForm.value['StuPhone']
    data['StuPRN'] = this.provisionalForm.value['StuPRN']
    data['CoName'] = this.TclcData[0]['CoName']
    data['CgName'] = this.provisionalForm.value['LastInst']
    data['StuId'] = this.StuId
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '140vh',
      height: '80vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }



  isPhotoDocument(row: FormGroup): string {
    const documentName = row.get('DocumentName')?.value;
    return documentName === 'Photo of Student' ? '.png, .jpeg, .jpg' : '.pdf';
  }


  onFileSelected($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "pdf") {
        this.convertBase64(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }

  }



  convertBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readingFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc2 = d;
      this.provisionalForm.get('UniDocUpload').clearValidators()
      this.provisionalForm.get('UniDocUpload').updateValueAndValidity();
      this.provisionalForm.get('UniDocUpload').setValue(d);
    });
  }
  readingFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  onChange($event: Event, rowIndex: number) {
    const fileInput = $event.target as HTMLInputElement;
    const formArray = this.provisionalForm.get('arrData') as FormArray;
    const formGroup = formArray.at(rowIndex) as FormGroup;

    const documentName = formGroup.get('DocumentName')?.value;
    // Set the accept attribute dynamically based on the document name
    if (documentName === 'Photo of student') {
      fileInput.setAttribute('accept', '.png, .jpeg, .jpg');
    } else {
      fileInput.setAttribute('accept', '.pdf');
    }

    // Get the selected file
    const file = fileInput.files[0];
    if (!file) {
      return; // Exit if no file is selected
    }

    this.fileName = file.name;
    const faControl = (<FormArray>this.provisionalForm.controls['arrData']).at(rowIndex);

    // File size validation
    if (file.size >= 1000000) {
      this.errormessage = 'Please upload a file smaller than 1 MB';
      const data = {
        message: this.errormessage,
        title: 'Information',
        icon: 'fas fa-close'
      };
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
      this.dialogRef.afterClosed().subscribe(() => {
        this.fileName = '';
        fileInput.value = '';
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
      });
    } else {
      this.errormessage = '';
      const ext = this.fileName.substring(this.fileName.lastIndexOf('.') + 1).toLowerCase();

      if (documentName === 'Photo of student' && (ext === 'png' || ext === 'jpeg' || ext === 'jpg')) {
        // If the document is a photo, proceed with setting the file
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(this.fileName);
        faControl.patchValue({ IsChanged: true});
        faControl['controls'].DocumentFile.markAsTouched();
      } else if (ext === 'pdf') {
        // If the document is a PDF, proceed with setting the file
        this.convertToBase64(file, rowIndex);
        faControl['controls'].DocumentFile.setValue(this.fileName);
        faControl.patchValue({IsChanged: true});
        faControl['controls'].DocumentFile.markAsTouched();
      } else {
        // Invalid file type for the document
        faControl['controls'].docFile.setValue('');
        faControl['controls'].DocumentFile.setValue('');
        faControl['controls'].DocumentFile.markAsTouched();
        const data = {
          message: documentName === 'Photo of student' ? 'Please upload only PNG, JPEG, or JPG files' : 'Please upload only PDF files',
          title: 'Information',
          icon: 'fas fa-close'
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.dialogRef.afterClosed().subscribe(() => {
          this.fileName = '';
          fileInput.value = '';
        });
      }
    }
  }



  convertToBase64(file: File, rowIndex: number) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDoc = d;
      // while (this.fileUploads.length <= rowIndex) {
      //   this.fileUploads.push(null);
      // }
      if (!this.fileUploads) {
        this.fileUploads = [];  // Initialize if it's undefined
      }

      // Check if the rowIndex exists in the array, and if not, create a placeholder
      if (!this.fileUploads[rowIndex]) {
        this.fileUploads[rowIndex] = {}; // Initialize row if it's missing
      }
      this.fileUploads[rowIndex] = d;
      let base64Str = d.split(',');
      let filee = base64Str[1];
      const faControl = (<FormArray>this.provisionalForm.controls['arrData']).at(rowIndex);
      faControl['controls'].docFile.setValue(filee);
      faControl['controls'].DocumentFile.setValue(file.name);

    });
  }

  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

   showbase64(e,index) {
  this.spinner.show();
   let fileData = this.fileUploads?.[index];
  if (fileData && typeof fileData === 'string' && fileData.includes('base64')) {
    this.spinner.hide();

    this.dialog.open(PdfviewerComponent, {
      width: "400px",
      height: "500px",
      data: fileData   
    });
    return;
  }
   let payload: any = {};
  payload['filePath'] = e.value.DocumentFile;
  this.umsService.fetchDocument(payload).subscribe((res) => {
    this.spinner.hide();

    if (res.status && res.doc) {
      this.dialog.open(PdfviewerComponent, {
        width: "400px",
        height: "500px",
        data: res.doc  
       });
    }
  });
}
  showbase64new(e) {
    const dialogRef3 = this.dialog.open(PdfviewerComponent, { 
      width: "400px", height: "500px", data: e });
  }

  dowload() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.AdminUpload.FileUpload
      });
  }


  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  ValidateFee(StuId, FeeType, Data) {

    const payload = {}
    payload['StuId'] = StuId;
    payload['FeeType'] = FeeType;
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateFees(payload).subscribe(res => {
      if (res.status) {
        this.getFeeTempData2(StuId, FeeType, Data);
      }
      else {
        this.getFeeTempData2(StuId, FeeType, Data);
        // this.finishedApi++
        // if (this.finishedApi === this.calledApi) {
        //   this.spinner.hide();
        // }
      }

    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }

  ValidateCertificateFee() {
    this.spinner.show()
    const payload = {}
    payload['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload['FeeType'] = this.CertificateType;
    payload['SnNo'] = sessionStorage.getItem('session');
    this.umsService.ValidateCertificateFees(payload).subscribe(res => {
      this.spinner.hide();
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }




  getFeeTempData2(StuId, FeeType, Data) {
    // this.spinner.show();
    const payload = {};
    payload['FeeType'] = FeeType;
    this.umsService.fetchFeeTempTclc(payload).subscribe(res => {
      // this.spinner.hide();
      if (res.status) {
        this.SearchFeeDetails(res.data[0]['TemplateCode'], StuId, Data)

      } else {
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
        if (res.message == 'No Data Found') {

        }

      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  SearchFeeDetails(TempCode, StdId, Data) {
    // this.spinner.show();
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StdId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = sessionStorage.getItem('session')
    payload['FeeType'] = this.certType
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.updateTC(StdId, Data)
        // let data = 0
        // res.data.forEach(element => {
        //   data += element.FeeAmt
        // });
        // if (data == res.data[0]['TotalPaidAmount']) {

        // }
        // else if (data != res.data[0]['TotalPaidAmount']) {
        // }
      } else {
        this.PayDisabled = false;
        this.PayRecpt = false;
        //this.PayFee = true;
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
this.Update(true)
  }

  updateTC(StdId, Data) {
    let submitpayload = this.provisionalForm.value
    let payload = {}
    payload['StuFaculty'] = Data['StuFaculty'],
      payload['StuCourse'] = submitpayload.CoCode,
      payload['StuCollege'] = Data['StuCollege'],
      payload['StuExam'] = Data['StuExam'],
      payload['StuBranch'] = Data['StuBranch'],
      payload['SnNo'] = parseInt(sessionStorage.getItem('session')),
      payload['CertType'] = Data['CertType'],
      payload['DestClg'] = Data['DestClg'],
      payload['Reason'] = Data['Reason'],
      payload['FeeStatus'] = 'Y';
    payload['CertStatus'] = 'Fees Paid';
    payload['StuId'] = Data['StuId'],
      payload['TclcId'] = Data['TclcId'],
      payload['Comment'] = '',
      payload['CertScr'] = '',
      payload['StatusBy'] = sessionStorage.getItem('loginId'),
      payload['StuEmail'] = '';
    payload['Copy'] = '';
    payload['Certificate'] = '';
    this.umsService.UpdateTclc(payload).subscribe((res) => {
      if (res.status) {
        this.getTclcData(StdId)
      }
      else {
        this.finishedApi++
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    })
  }



  onYearRegSelect(year2: number) {
    if (!this.PassYearList.some(y => y.year === year2)) {
      this.PassYearList.push({ year: year2, description: `Year ${year2}` });
    }
    this.filteredPassYearList = Array.from(new Set(this.PassYearList.map(y => y.year)))
      .map(year => this.PassYearList.find(y => y.year === year)!);
    this.filteredPassYearList2 = Array.from(new Set(this.PassYearList.map(y => y.year)))
      .map(year => this.PassYearList.find(y => y.year === year)!);

    this.provisionalForm.controls['regnYear'].setValue(year2);
  }

  fetchPhdYear() {
    const currentYear = new Date().getFullYear();
    this.PhdYearList = Array.from({ length: 100 }, (_, i) => {
      const year = currentYear - i;
      return { year, description: `Year ${year}` };
    });
    this.filteredPhdYearList = [...this.PhdYearList];
  }
  onPhdYearSelect(year: number) {
    // Only add if not already in list
    const alreadyExists = this.PhdYearList.find(y => y.year === year);
    if (!alreadyExists) {
      this.PhdYearList.push({ year, description: `Year ${year}` });
      this.PhdYearList.sort((a, b) => b.year - a.year);
    }

    this.filteredPhdYearList = [...this.PhdYearList]; // Refresh dropdown
    this.provisionalForm.controls['PhdCompletionYear'].setValue(year); // Set value
  }

  // onPhdYearSelect(year2: number) {
  //   if (!this.PhdYearList.some(y => y.year === year2)) {
  //     this.PhdYearList.push({ year: year2, description: `Year ${year2}` });
  //   }
  //     this.filteredPhdYearList = Array.from(new Set(this.PhdYearList.map(y => y.year)))
  //     .map(year => this.PhdYearList.find(y => y.year === year)!);

  //   this.provisionalForm.controls['PhdCompletionYear'].setValue(year2);
  // }

  getCertificateCourses(CoCode) {
    this.spinner.show();
    const payload = {};
    payload['CourseCode'] = CoCode;

    this.umsService.getCertCourse(payload).subscribe((res) => {
      if (res.status) {
        console.log(res, 'res');
        this.sortSequence = res.data[0].SortSequence
        this.ReportCoCode = res.data[0].ReportCoCode
      }
    })
  }


  Print() {
    if (this.certType == 'RC') {
       let qrPayload = { 
      Stuid: this.StuId, 
      CertType: this.certType,
       LoginId: parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        InstNo: this.InstId ? this.InstId : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.StuId,
        CertType: this.certType,
        qrUrl: res.url
      };
      var filter: any;
      payload1['Stuid'] = this.StuId
      payload1['CertType'] = this.certType;
      let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        "RptCode": 304,
        "InstName": '',
        "InstNo": this.InstId ? this.InstId : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
      });
    }
       else if (this.certType == 'PC') {
      var filter: any;
    let qrPayload = { 
      Stuid: this.StuId, 
      CertType: this.certType,
       LoginId: parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        InstNo: this.InstId ? this.InstId : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode,
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.StuId,
        CertType: this.certType,
        qrUrl: res.url
      };
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        "RptCode": 303,
        "InstName": '',
        "InstNo": this.InstId ? this.InstId : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": this.ReportCoCode, //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
          });
    }
    else if (this.certType == 'MC') {
     let qrPayload = { 
      Stuid: this.StuId, 
      CertType: this.certType,
       LoginId: parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        InstNo: this.InstId ? this.InstId : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.StuId,
        CertType: this.certType,
        qrUrl: res.url
      };
      var filter: any;
      payload1['Stuid'] = this.StuId
      payload1['CertType'] = this.certType;
      let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        "RptCode": 306,
        "InstName": '',
        "InstNo": this.InstId ? this.InstId : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
      });
    }
    else if (this.certType == 'OPC') {
       let qrPayload = { 
      Stuid: this.StuId, 
      CertType: this.certType,
       LoginId: parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        InstNo: this.InstId ? this.InstId : 0, 
        SnNo: this.Tclcdata['SnNo'] ,
        CoCode: this.ReportCoCode
      };
    this.umsService.generateQR(qrPayload).subscribe((res: any) => {
      let payload1: any = {
        Stuid: this.StuId,
        CertType: this.certType,
        qrUrl: res.url
      };
      var filter: any;
      payload1['Stuid'] = this.StuId
      payload1['CertType'] = this.certType;
      payload1['SortSequence'] = this.sortSequence;
      let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
      var filter: any;
      filter = {
        "LoginId": parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
        "RptCode": 305,
        "InstName": '',
        "InstNo": this.InstId ? this.InstId : 0,
        "ShId": '',
        "CgCode": '',
        "RollNo": '',
        "Cent": '',
        "TnCode": '',
        "EsId": '',//this.emid
        "CsNo": '',
        "PgBreak": '',
        "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
        "StrCode": '',
        "RgNo": '',
        "UC": '',
        "Ledger": '',
        "RegnRoll": '',
        "DsCode": '',
        "CoCode": this.ReportCoCode, //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
        "SnNo": this.Tclcdata['SnNo'],
        "Extra1": JSON.stringify(payload1),
      }
      var payload: any;
      payload = filter;
      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
      });
    }
  }


  redirect(to): void {
    this.router.navigate([to]);
  }

  specialItem(item: any) {
    this.specItem = item
    const internDateControl = this.provisionalForm.get('InternDate');
    if (item == 'Medical Laboratory Technology') {
      internDateControl.setValidators([Validators.required]);
      internDateControl.markAsTouched();
      this.showInput = true;
    } else {
      internDateControl.clearValidators();
      internDateControl.setValue('');
      this.showInput = false;
    }
    internDateControl.updateValueAndValidity();

    // Apply validators for course-based fields
    // const creds = this.provisionalForm.get('arrData') as FormArray;

    // if (item == 'Medical Laboratory Technology') {
    //   creds.controls.forEach(element => {

    //     const documentFileValue = element.get('DocumentFile').value;
    //     const documentNameValue = element.get('DocumentName').value;
    //     console.log(documentNameValue);

    //     if (documentNameValue === 'Internship completion certificate(wherever applicable)') {
    //       element.get('DocumentFile').setValidators([Validators.required]);
    //       element.get('DocumentFile').markAsTouched();
    //     }
    //     element.get('DocumentFile').updateValueAndValidity();
    //   });
    // }
  }
  saveFiles() {
    let payload2 = this.provisionalForm.value;
    let filesArray: any[] = [];
    payload2.arrData.forEach((element, index) => {
      if (!this.fileUploads[index]) {
      return; 
    }


    const payload = {
      filePath: element.filePath
      //base64: this.fileUploads[index],
      //fileName: element.DocumentFile 
    };

    this.umsService.saveFiles(payload).subscribe(
      (res) => {
        console.log("savefile11",payload);
         console.log("S3 upload success111:", res.mainPath);
        console.log('Uploaded111:', res);
      },
      (error) => {
        console.error(error);
      }
    );

  });
  }

  saveFiles1() {
  let payload2 = this.provisionalForm.value;

  payload2.arrData.forEach((element, index) => {
    if (!this.fileUploads[index]) {
      return;
    }
    const doc = this.filePathData.find(d => d.DocNo === element.DocNo);

    if (!doc || !doc.filePath) {
      console.error("FilePath not found for DocNo:", element.DocNo);
      return;
    }
    const payload = {
      filePath: doc?.filePath,       
      base64: this.fileUploads[index]
     // fileName: element.DocumentFile  
     // filePath: element.filePath
    };

    console.log("Uploading payload:", payload);

    this.umsService.saveFiles(payload).subscribe(
      (res) => {
        console.log("S3 upload success:", res.mainPath);
      },
      (error) => {
        console.error("Upload error:", error);
      }
    );

  });
}
  getFilePathData(StuId) {
  let payload: any = {};
  payload['StuId'] = StuId;

  this.umsService.GetTcLcDocDetailsFile(payload).subscribe(
    (res) => {
      if (res.status) {
        console.log("FilePath APIqqqqq:", res.data);

        this.filePathData = res.data; 
      }
    },
    (error) => {
      console.error("FilePath API error:", error);
    }
  );
}
}